import React, { useEffect, useState, useContext } from "react";
import moment from "moment";
import { WrapperContext } from "../components/Layout";
import Article from "../components/Article";
import Loader from "../components/ui/Loader";

const Index = () => {
  const { date } = useContext(WrapperContext);
  const [isLoading, setIsLoading] = useState(true);
  const [feed, setFeed] = useState([]);

  useEffect(() => {
    console.log(date);
    if (!date) return;
    //https://en.wikipedia.org/api/rest_v1/feed/onthisday/events/06/06
    const apiUrl = `https://en.wikipedia.org/api/rest_v1/feed/onthisday/events/${date.monthNum}/${date.dayNum}`;

    getItems(apiUrl);
    // fetch(apiUrl)
    //   .then(response => response.json())
    //   .then(data => {
    //     // console.log(data);

    //   });
  }, [date]);

  const getItems = async (apiUrl) => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    // await axios.get(`https://jsonplaceholder.typicode.com/photos?_page=${page}&_limit=5`)
    await fetch(apiUrl)
      .then((response) => response.json())
      .then((resp) => {
        console.log(resp.events);
        // setItems([...items, ...resp.data]);
        const sortedByDate = resp.events.sort((a, b) => b.year - a.year);
        setFeed([...feed, ...sortedByDate]);
        setIsLoading(false);
      });
  };

  // const _getFormatedMonthDay = () => {
  //   const today = new Date();
  //   const month = moment(today).format("MM");
  //   const day = moment(today).format("DD");
  //   return `${month}/${day}`;
  // };

  return (
    <div className='feed'>
      {date && (
        <div className='today p-sm pr-xs tabnum strong'>{`${date.month}, ${date.day}`}</div>
      )}
      {isLoading && <Loader />}
      {feed.map((item, i) => (
        <Article input={item} key={i} />
      ))}
    </div>
  );
};

export default Index;
